<template>
    <app-content-admin>
        <template slot="header">Add Ad</template>
        <template slot="button">
            <v-btn style="margin-left: auto" large color="secondary" to="/ad">
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Ad Name')"
                                        v-model="form.ads_name"
                                        :rules="[rules.required('Ad Name')]"
                                        :data-label="$t('Ad Name')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Link Url')"
                                        v-model="form.ads_url"
                                        :rules="[rules.required('Link Url')]"
                                        :data-label="$t('Link Url')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Active')"
                                        v-model="form.ads_active"
                                        :data-label="$t('Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>

                                <v-flex xs12>
                                    <input
                                        type="datetime-local"
                                        v-model="form.ads_start_date"
                                        @input="formatStartDate"
                                    />
                                </v-flex>
                                <v-flex xs12>
                                    <input
                                        type="datetime-local"
                                        v-model="form.ads_end_date"
                                        @input="formatEndDate"
                                    />
                                </v-flex>
                                <v-select
                                    v-model="form.selectedPlacementNames"
                                    :items="this.GetPlacementNames"
                                    label="Placement Name"
                                    multiple
                                    clearable
                                    placeholder="Select Placemnt Names"
                                    persistent-hint
                                    single-line
                                    :rules="[
                                        (v) =>
                                            (!!v && v.length > 0) ||
                                            'Please select at least one Zone Name',
                                    ]"
                                />

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Image Url')"
                                        v-model="form.ads_external_img"
                                        :rules="[rules.required('Image Url')]"
                                        :data-label="$t('Image Url')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-row>
                                        <v-col cols="10">
                                            <div class="dropzone-wrapper">
                                                <vue-dropzone
                                                    ref="myDropzone"
                                                    id="dropzone"
                                                    :options="dropzoneOptions"
                                                    @vdropzone-success="
                                                        onUploadSuccess
                                                    "
                                                ></vue-dropzone>
                                            </div>
                                        </v-col>
                                        <v-col cols="2">
                                            <div class="upload-button-wrapper">
                                                <v-btn
                                                    @click="handleUploadClick"
                                                    >Upload</v-btn
                                                >
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-flex>

                                <v-flex xs12 v-if="isImageUrlValid">
                                    <v-img
                                        :width="500"
                                        :height="500"
                                        aspect-ratio="16/9"
                                        cover
                                        :src="form.ads_external_img"
                                    ></v-img>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Image Description')"
                                        v-model="form.ads_description"
                                        :rules="[
                                            rules.required('Image Description'),
                                        ]"
                                        :data-label="$t('Image Description')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Max Time')"
                                        v-model="form.ads_maxtimes"
                                        :data-label="$t('Max Time')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_maxtimes'
                                            )
                                        "
                                        :rules="[rules.required('Max Time')]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Daily Max Time')"
                                        v-model="form.ads_daily_maxtimes"
                                        :data-label="$t('Daily Max Time')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_daily_maxtimes'
                                            )
                                        "
                                        :rules="[
                                            rules.required('Daily Max Time'),
                                        ]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('User Daily Max Time')"
                                        v-model="form.ads_user_daily_maxtimes"
                                        :data-label="$t('User Daily Max Time')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_user_daily_maxtimes'
                                            )
                                        "
                                        :rules="[
                                            rules.required(
                                                'User Daily Max Time'
                                            ),
                                        ]"
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Max Clicks')"
                                        v-model="form.ads_maxclicks"
                                        :data-label="$t('Max Clicks')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="
                                            handlingZeroNegativeValue(
                                                'ads_maxclicks'
                                            )
                                        "
                                        :rules="[rules.required('Max Clicks')]"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="createAd"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "vue2-dropzone";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                ads_name: null,
                ads_url: null,
                ads_active: 0,
                ads_external_img: null,
                ads_start_date: null,
                ads_end_date: null,
                relatedPlacementIds: [],
                placement_ids: [], // Initialize zone_ids as an empty array

                selectedPlacementNames: [],
                placement_names: [],

                //Image detail info
                ads_description: null,
                ads_maxtimes: 0,
                ads_daily_maxtimes: 0,
                ads_user_daily_maxtimes: 0,
                ads_maxclicks: 0,
            },
            GetPlacementNames: [],
            dropzoneOptions: {
                url: "https://api.imgur.com/3/upload", // specify your upload endpoint
                maxFilesize: 3, // set maximum file size in MB
                acceptedFiles: "image/jpeg,image/png", // specify accepted file types
                addRemoveLinks: true, // show remove links on uploaded files
                maxFiles: 1,
                autoProcessQueue: false, // prevent automatic upload
            },
        };
    },

    components: { ActiveLabel, VueDropzone },

    created() {
        //Call first then display all placement id
        this.getAllPlacementIds();
    },
    computed: {
        //Validation image url
        isImageUrlValid() {
            // Use a regular expression to validate the URL format
            const urlPattern =
                /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;
            return urlPattern.test(this.form.ads_external_img);
        },
    },

    methods: {
        //Create new Ad data
        async createAd() {
            let loader = this.$loading.show();
            try {
                this.form.placement_names = this.form.selectedPlacementNames;
                let res = await axios.post(`/api/auth/create_ad`, this.form);

                if (res.status == 200) {
                    console.log("Create Ad Success", res.ad);
                    this.$toastr.s("Ad created successfully");
                    this.$router.push("/ad");
                }
            } catch (err) {
                if (err.response.status === 400) {
                    // Validation errors returned by the server
                    console.log("Error Form Data:", this.form); // Log the form data before sending the request

                    //this.$toastr.e("Please input all required data");
                } else {
                    //   console.log("Error status:", err.response.status);
                    //   this.$toastr.e("An error occurred while creating the Ad.");
                    console.log("Error create ad", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Read all placement data
        getAllPlacementIds() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_placement_list`)

                .then((res) => res.data)
                .then((res) => {
                    this.GetPlacementNames = res.result.map(
                        (placement) => placement.placement.placement_name
                    );
                    console.log("All Placement Names:", this.GetPlacementNames);
                })

                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        updatePlacementIds() {
            this.form.placement_ids = this.form.selectedPlacementIds;
        },

        //Modify date ui data format so match backend date format allow create api integrate success
        formatStartDate() {
            if (this.form.ads_start_date) {
                const date = new Date(this.form.ads_start_date);
                this.form.ads_start_date = date
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " ");
            }
        },

        formatEndDate() {
            if (this.form.ads_end_date) {
                const date = new Date(this.form.ads_end_date);
                this.form.ads_end_date = date
                    .toISOString()
                    .slice(0, 19)
                    .replace("T", " ");
            }
        },

        handlingZeroNegativeValue(field) {
            // Ensure that the value is not negative
            if (this.form[field] < 0) {
                this.form[field] = 0;
            }

            // Remove leading zeros
            if (this.form[field].length > 1 && this.form[field][0] === "0") {
                this.form[field] = this.form[field].slice(1);
            }
        },
        onUploadSuccess(file, response) {
            console.log("File uploaded:", file);
            console.log("Server response:", response);
        },
        handleUploadClick() {
            

            let loader = this.$loading.show();

            axios
                .get(`/api/auth/image_upload`)

                .then((res) => res.data)
                .then((res) => {
                   
                    console.log("Upload Success");
                })

                .catch((e) => {
                 
                    console.log("Upload Fail",);
                   // this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },
    },
};
</script>
